import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { BuildYourCourseComponent, ConfirmationComponent, YourInformationComponent } from './components';
import { StepResolverService } from './services';
import { RouteIds } from './types';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: RouteIds.buildYourCourse,
    pathMatch: 'full',
  },
  {
    path: RouteIds.buildYourCourse,
    component: BuildYourCourseComponent,
    resolve: { step: () => inject(StepResolverService).resolve(RouteIds.buildYourCourse) },
  },
  {
    path: RouteIds.yourInformation,
    component: YourInformationComponent,
    resolve: { step: () => inject(StepResolverService).resolve(RouteIds.yourInformation) },
  },
  {
    path: RouteIds.confirmation,
    component: ConfirmationComponent,
    resolve: { step: () => inject(StepResolverService).resolve(RouteIds.confirmation) },
  },
  {
    path: '**',
    redirectTo: RouteIds.buildYourCourse,
  },
];
